module.exports = __webpack_public_path__ + "img/retrospect-102.07d13118.jpg";